/* eslint-disable */

export const CANCEL_DEPTH_BOT_ORDERS = {
    FETCH_CANCEL_DEPTH_BOT_ORDERS_REQUEST: 'FETCH_CANCEL_DEPTH_BOT_ORDERS_REQUEST',
    FETCH_CANCEL_DEPTH_BOT_ORDERS_SUCCESS: 'FETCH_CANCEL_DEPTH_BOT_ORDERS_SUCCESS',
    FETCH_CANCEL_DEPTH_BOT_ORDERS_FAILURE: 'FETCH_CANCEL_DEPTH_BOT_ORDERS_FAILURE',
};
